// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".year-model .ans-radio-group-vertical .ans-radio-wrapper{margin:5px 0;display:inline-block}", ""]);
// Exports
module.exports = exports;
